var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('clone-form-modal',{ref:"clone_modal",attrs:{"clone_url":_vm.clone_url,"company_form":true}}),_vm._v(" "),_c('list-component',{attrs:{"items":_vm.forms,"action_url":_vm.action_url,"toggle_property":"active","update_toggle_url":_vm.update_toggle_url,"options":_vm.options},on:{"clone":_vm.cloneModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }